<template>
  <div class="columns">
    <div class="column col-12 form-group gd-item-executant">
      <div class="gd-read">
        <label class="form-label">Executante</label>
        <div class="gd-read-value">{{ item.professionalName || '—' }}</div>
      </div>
      <span class="gd-sub" v-if="executantText">
        <template v-if="executantCouncil">{{ executantCouncil }}</template>
        <template v-if="executantCouncil && executantCbo"> · </template>
        <span v-if="executantCbo" :class="{tooltip: !!executantCbo.name}"
              :data-tooltip="executantCbo.name">CBO {{ executantCbo.code }}</span>
      </span>
      <span class="gd-sub gd-warn" v-else-if="item.professionalId">
        Sem conselho ou CBO cadastrado
      </span>
    </div>
    <div class="column col-3 col-md-4 col-sm-6 form-group">
      <label class="form-label">Data de execução</label>
      <dx-input-date class="form-input" v-model="item.executionDate" :disabled="readonly"
                     @input="$emit('change')"/>
    </div>
    <div class="column col-2 col-md-4 col-sm-6 form-group">
      <label class="form-label">Hora inicial</label>
      <input type="text" class="form-input" v-model="item.startTime" v-mask="'00:00'"
             placeholder="00:00" :readonly="readonly">
    </div>
    <div class="column col-2 col-md-4 col-sm-6 form-group">
      <label class="form-label">Hora final</label>
      <input type="text" class="form-input" v-model="item.endTime" v-mask="'00:00'"
             placeholder="00:00" :readonly="readonly">
    </div>
    <div class="column col-5 col-md-12 form-group">
      <label class="form-label">Grau de participação</label>
      <select class="form-select" v-model="item.degreeParticipation" :disabled="readonly">
        <option value="">—</option>
        <option v-for="(text, value) in degrees" :value="value" :key="value">{{ text }}</option>
      </select>
    </div>
    <div class="column col-3 col-md-4 col-sm-6 form-group" :class="{'has-error': err('way')}">
      <label class="form-label">
        Via de acesso
        <small v-if="requiresWayTechnique">exigida neste convênio</small>
      </label>
      <select class="form-select" v-model="item.way" :disabled="readonly"
              @blur="touch('way')" @change="touch('way')">
        <option value="">—</option>
        <option v-for="(text, value) in ways" :value="value" :key="value">{{ text }}</option>
      </select>
      <div class="form-input-hint" v-if="err('way')">Campo obrigatório</div>
    </div>
    <div class="column col-3 col-md-4 col-sm-6 form-group"
         :class="{'has-error': err('technique')}">
      <label class="form-label">
        Técnica
        <small v-if="requiresWayTechnique">exigida neste convênio</small>
      </label>
      <select class="form-select" v-model="item.technique" :disabled="readonly"
              @blur="touch('technique')" @change="touch('technique')">
        <option value="">—</option>
        <option v-for="(text, value) in techniques" :value="value" :key="value">{{ text }}</option>
      </select>
      <div class="form-input-hint" v-if="err('technique')">Campo obrigatório</div>
    </div>
    <div class="column col-3 col-md-4 col-sm-12 form-group gd-switch-column"
         v-if="item.expense.type === 'consultation'">
      <label class="form-label">&nbsp;</label>
      <label class="form-switch">
        <input type="checkbox" v-model="item.return" :disabled="readonly"
               @change="$emit('change')">
        <i class="form-icon"></i>Retorno (sem cobrança)
      </label>
    </div>
  </div>
</template>

<script>
import { degreesParticipation } from '@/data/degrees-participation';
import { ways } from '@/data/expense-ways';
import { techniques } from '@/data/expense-techniques';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    v: {
      type: Object,
      default: null,
    },
    professionals: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      degrees: degreesParticipation,
      ways,
      techniques,
    };
  },
  computed: {
    requiresWayTechnique() {
      return !!(this.item.rules && this.item.rules.requireWayTechnique);
    },
    executantOption() {
      if (!this.item.professionalId) return null;
      const value = `${this.item.professionalId}|${this.item.specialtyCode || ''}`;
      return this.professionals.find(option => option.value === value) || null;
    },
    executantCouncil() {
      const option = this.executantOption;
      const council = option ? option.council : null;
      return council && council.record ? `${council.name}-${council.state} ${council.record}` : '';
    },
    executantCbo() {
      const option = this.executantOption;
      const specialty = option ? option.specialty : null;
      return specialty && specialty.code ? specialty : null;
    },
    executantText() {
      return [this.executantCouncil, this.executantCbo ? `CBO ${this.executantCbo.code}` : '']
        .filter(Boolean)
        .join(' · ');
    },
  },
  methods: {
    err(field) {
      const node = this.v ? this.v[field] : null;
      return !!(node && node.$error);
    },
    touch(field) {
      const node = this.v ? this.v[field] : null;
      if (node && typeof node.$touch === 'function') node.$touch();
    },
  },
};
</script>
